const formatNumber = (amount: number) => {
  const cash = Math.round(amount / 10) * 10;
  if (cash === undefined) {
    return 0;
  }

  return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  //   return cash.toFixed(1).replace(/\d(?=(\d{3})+\.)/g, "$&,");
};

export { formatNumber };
